import { render, staticRenderFns } from "./RepairWarrantyPieChart.vue?vue&type=template&id=4490f40c&"
import script from "./RepairWarrantyPieChart.vue?vue&type=script&lang=js&"
export * from "./RepairWarrantyPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports